import {useState} from "react";
import {Link} from "@/shared/ui/Link";
import {Svg} from "@/shared/ui/Svg";
import {Picture} from "@/shared/ui/Picture";
import {FooterData} from "../model/types";
import {FooterSocials} from "./FooterSocials/FooterSocials";
import {FooterNavItem} from "./FooterNavItem/FooterNavItem";
import styles from "./Footer.module.scss";

type Props = {
    hideFooter: boolean;
    hideMainFooter: boolean;
    footerData: FooterData;
}

export const Footer = (
    {
        hideFooter = false,
        hideMainFooter = false,
        footerData,
    }: Props
) => {
    const {apps = [], socials = [], navigation = []} = footerData;

    const [openedItem, setOpenedItem] = useState<string | null>(null);
    const toggleItem = (id: string) => {
        setOpenedItem(prev => (
            prev === id ? null : id
        ));
    };

    const currentYear = new Date().getFullYear();

    if (hideFooter) return null;

    return (
        <footer className={styles.footer}>
            {!hideMainFooter && (
                <>
                    <div className={`globalContainer`}>
                        <div className={styles.mainContainer}>
                            <Link href={'/'} className={styles.logoContainer}>
                                <Svg id={`main-logo`} className={styles.logoIcon} />
                            </Link>
                            <div className={styles.desktopAppsContainer}>
                                <p className={styles.navItemTitle}>Мобильное приложение</p>
                                <div className={styles.qrIcon}>
                                    <Picture src={`/storage/img/footer/qr/qrIcon.png`} alt={`qrIcon`} />
                                </div>
                                <p className={styles.qrText}>Наведите камеру на QR-код и скачайте приложение</p>
                                <div className={styles.appsIcons}>
                                    {apps.map((apps) => (
                                        <a
                                            key={apps.href}
                                            href={apps.href}
                                            className={styles.appsIcon}
                                            target={`_blank`}
                                        >
                                            <Picture src={apps.icon} alt={apps.alt} />
                                        </a>
                                    ))}
                                </div>
                            </div>
                            <div className={styles.navContainer}>
                                {navigation.map((item) => (
                                    <FooterNavItem
                                        key={item.id}
                                        item={item}
                                        opened={openedItem === item.id}
                                        onToggle={() => toggleItem(item.id)}
                                    >
                                        {item.showSocials && (
                                            <FooterSocials socials={socials} className={styles.socialsDesktop} />
                                        )}
                                    </FooterNavItem>
                                ))}
                            </div>
                            <div className={styles.mobileAppsContainer}>
                                <div className={styles.mobileAppsInfo}>
                                    <div className={styles.mobileAppsIconContainer}>
                                        <Svg id={`main-logo-mobile`} className={styles.mobileAppsIcon} />
                                    </div>
                                    <div className={styles.mobileAppsContent}>
                                        <p className={styles.mobileAppsTitle}>Приложение Platina</p>
                                        <p className={styles.mobileAppsText}>
                                            Акции, доставка и больше бонусов за покупки
                                        </p>
                                    </div>
                                </div>
                                <a href={`https://platina.onelink.me/XKls/3h9xijzw`}
                                   className={styles.mobileAppsLink}
                                   role={`button`}
                                   target={`_blank`}
                                >
                                    <span className={styles.mobileAppsLinkText}>Скачать приложение</span>
                                </a>
                            </div>
                            <FooterSocials socials={socials} className={styles.socialsMobile} />
                        </div>
                    </div>
                    <div className={styles.line}></div>
                </>
            )}
            <div className={`globalContainer`}>
                <div className={styles.yearContainer}>
                    <p className={styles.yearText}>
                        &copy;&nbsp;ООО&nbsp;ЮЗ&nbsp;&laquo;ПЛАТИНА&raquo;, 2015 - {currentYear}
                    </p>
                </div>
            </div>
        </footer>
    );
}
